import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { DocumentType } from "../../../api/caseDocuments";
import { useAppDispatch, useAppSelector } from "../../../app/store";
import { ErrorDisplay } from "../../../components/ui/error/ErrorDisplay";
import { CustomLoadingSpinner } from "../../../components/ui/spinners/LoadingSpinner";
import { fetchCaseDocuments } from "../../../thunks/caseDocument";
import {
  selectDocumentsError,
  selectDocumentsLoading,
} from "../logic/caseDocumentsSelector";
import DocumentSection from "./DocumentSection";
import { RETRIEVING_DATA_SUBTITLE } from "../../../lib/constants";

const InvestigationDocumentsPage = () => {
  const { id: caseId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const isPending = useAppSelector(selectDocumentsLoading);
  const fetchError = useAppSelector(selectDocumentsError);

  useEffect(() => {
    !!caseId && dispatch(fetchCaseDocuments({ case_id: caseId }));
  }, [caseId, dispatch]);

  if (!caseId) return null;

  const handleRetry = () => {
    dispatch(fetchCaseDocuments({ case_id: caseId }));
  };

  if (isPending) {
    return (
      <CustomLoadingSpinner
        title="Loading Documents..."
        subtitle={RETRIEVING_DATA_SUBTITLE}
        minHeight="min-h-[576px]"
      />
    );
  }

  if (fetchError) {
    return <ErrorDisplay error={fetchError} onRetry={handleRetry} />;
  }

  const renderNonEmptyView = () => {
    return (
      <div className="w-full h-full flex flex-col overflow-auto">
        <DocumentSection
          documentType={DocumentType.INVESTIGATION_REPORT}
          isSingleton={true}
        />

        <div className="my-4 h-px w-full bg-[#E5E5E5]" />

        <DocumentSection
          documentType={DocumentType.INVESTIGATION_SUPPORTING}
          isSingleton={false}
        />
      </div>
    );
  };

  return (
    <div className="w-full h-[576px] border border-gray-100 shadow-overviewCard rounded-xl bg-white p-4">
      {renderNonEmptyView()}
    </div>
  );
};

export default InvestigationDocumentsPage;